import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"
import { getPlants } from "@shared/api/plants"
import type { Plant } from "@shared/api/plants/types"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type State = {
	plants: Plant[]
}

type Actions = {
	fetchPlants: (apiClient: APIClient) => Promise<void>
	resetStore: () => void
}

export const usePlantsStore = create<State & Actions>()(
	immer(set => ({
		plants: [],

		fetchPlants: async (apiClient: APIClient) => {
			const plants = await getPlants(apiClient)

			set(state => {
				state.plants = plants
			})
		},

		resetStore: () => {
			set(state => {
				state.plants = []
			})
		},
	})),
)
